import styled from 'styled-components';
import { colors } from '../../../utils/colors';

export const ButtonCircleBox = styled.button`
  background-color: ${colors.verde05};
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  color: ${colors.branco};
  cursor: pointer;
  margin-bottom: 26px;
  transition: all 0.5s;

  &:hover {
    background-color: ${colors.branco} !important;
    color: ${colors.verde} !important;
    border: 1px solid ${colors.verde05} !important;
  }
`;
